(function() {
  'use strict';

  function initInstitutionalTabs() {
    const dropdownWrappers = document.querySelectorAll('.ec-institutional-tabs__dropdown-wrapper');
    
    dropdownWrappers.forEach(function(wrapper) {
      if (wrapper.hasAttribute('data-initialized')) {
        return;
      }
      
      wrapper.setAttribute('data-initialized', 'true');
      wrapper.setAttribute('data-open', 'false');
      
      const section = wrapper.closest('.ec-institutional-tabs');
      const sectionId = section.classList[1].replace('ec-institutional-tabs--', '');
      const radios = document.querySelectorAll(`input[name="ec-institutional-tabs-${sectionId}"]`);
      const button = wrapper.querySelector('.ec-institutional-tabs__dropdown-button');
      const buttonText = wrapper.querySelector('.ec-institutional-tabs__dropdown-button-text');
      const list = wrapper.querySelector('.ec-institutional-tabs__dropdown-list');
      const items = wrapper.querySelectorAll('.ec-institutional-tabs__dropdown-item');
      
      const tabs = section.querySelectorAll('.ec-institutional-tabs__tab[data-tab-slug]');
      const slugMap = {};
      tabs.forEach(function(tab) {
        const slug = tab.getAttribute('data-tab-slug');
        const forId = tab.getAttribute('for');
        if (slug && forId) {
          const match = forId.match(/-(\d+)$/);
          if (match) {
            slugMap[slug] = parseInt(match[1], 10);
          }
        }
      });

      function updateHash(slug) {
        if (history.replaceState) {
          history.replaceState(null, '', slug ? '#' + slug : location.pathname + location.search);
        } else {
          location.hash = slug ? '#' + slug : '';
        }
      }

      function activateTab(index) {
        const radio = radios[index];
        if (!radio) return;
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        updateButtonText(index);
        updateActiveItem(index);
      }

      function updateButtonText(selectedIndex) {
        const selectedItem = items[selectedIndex];
        if (selectedItem && buttonText) {
          buttonText.textContent = selectedItem.textContent.trim();
        }
      }
      
      function updateActiveItem(selectedIndex) {
        items.forEach(function(item, index) {
          if (index === selectedIndex) {
            item.classList.add('ec-institutional-tabs__dropdown-item--active');
            item.setAttribute('aria-selected', 'true');
          } else {
            item.classList.remove('ec-institutional-tabs__dropdown-item--active');
            item.setAttribute('aria-selected', 'false');
          }
        });
      }
      
      function closeDropdown() {
        wrapper.setAttribute('data-open', 'false');
        button.setAttribute('aria-expanded', 'false');
      }
      
      function openDropdown() {
        wrapper.setAttribute('data-open', 'true');
        button.setAttribute('aria-expanded', 'true');
      }
      
      function toggleDropdown() {
        const isOpen = wrapper.getAttribute('data-open') === 'true';
        if (isOpen) {
          closeDropdown();
        } else {
          openDropdown();
        }
      }
      
      button.addEventListener('click', function(e) {
        e.stopPropagation();
        toggleDropdown();
      });

      tabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
          const slug = tab.getAttribute('data-tab-slug');
          if (slug) updateHash(slug);
        });
      });
      
      items.forEach(function(item, index) {
        item.addEventListener('click', function(e) {
          e.stopPropagation();
          const selectedIndex = parseInt(item.getAttribute('data-value'));
          const slug = item.getAttribute('data-tab-slug');
          
          if (radios[selectedIndex]) {
            activateTab(selectedIndex);
            if (slug) updateHash(slug);
            closeDropdown();
          }
        });
      });
      
      radios.forEach(function(radio, index) {
        radio.addEventListener('change', function() {
          if (this.checked) {
            updateButtonText(index);
            updateActiveItem(index);
          }
        });
      });
      
      document.addEventListener('click', function(e) {
        if (!wrapper.contains(e.target)) {
          closeDropdown();
        }
      });
      
      var hash = location.hash ? location.hash.slice(1) : '';
      if (hash && slugMap.hasOwnProperty(hash)) {
        activateTab(slugMap[hash]);
      } else {
        const firstChecked = Array.from(radios).findIndex(function(radio) {
          return radio.checked;
        });
        if (firstChecked >= 0) {
          updateButtonText(firstChecked);
          updateActiveItem(firstChecked);
        }
      }
    });
  }

  function initFAQAccordions() {
    const faqDetails = document.querySelectorAll('.ec-institutional-tabs__faq-details');
    
    faqDetails.forEach(function(details) {
      updateFAQIcon(details);
      
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
            updateFAQIcon(details);
          }
        });
      });
      
      observer.observe(details, {
        attributes: true,
        attributeFilter: ['open']
      });
    });
  }

  function updateFAQIcon(details) {
    const iconPlus = details.querySelector('.ec-institutional-tabs__faq-icon-plus');
    const iconMinus = details.querySelector('.ec-institutional-tabs__faq-icon-minus');
    
    if (details.hasAttribute('open')) {
      if (iconPlus) iconPlus.style.opacity = '0';
      if (iconMinus) iconMinus.style.opacity = '1';
    } else {
      if (iconPlus) iconPlus.style.opacity = '1';
      if (iconMinus) iconMinus.style.opacity = '0';
    }
  }

  function init() {
    initInstitutionalTabs();
    initFAQAccordions();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
